import { render, staticRenderFns } from "./Claim.vue?vue&type=template&id=5fda1ba2&scoped=true&"
import script from "./Claim.vue?vue&type=script&lang=js&"
export * from "./Claim.vue?vue&type=script&lang=js&"
import style0 from "./Claim.vue?vue&type=style&index=0&id=5fda1ba2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda1ba2",
  null
  
)

export default component.exports